import React, { Fragment, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { H3 } from '../../../Themes/Components/AbstractElements';
import ReactApexChart from 'react-apexcharts';

const PieChart = ({ data }) => {
  const [dadosFormatados, setDadosFormatados] = useState({
    series: [],
    options: {
      labels: [],
    },
  });

  useEffect(() => {
    if (data && data.data) {
      const dados = {
        series: data.data.data,
        options: {
          labels: data.data.labels,
          colors: data.data.colors,
          plotOptions: {
            pie: {
              dataLabels: {
                offset: -10,
                minAngleToShowLabel: 10,
              },
            },
          },
          dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
              const value = opts.w.globals.series[opts.seriesIndex];
              return value + ' (' + val.toFixed(1) + '%)';
            },
          },
          legend: {
            position: 'bottom',
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
          ],
        },
      };

      setDadosFormatados(dados);
    }
  }, [data]);

  return (
    <Fragment>
      <Card>
        <CardHeader className='pb-0'>
          <H3>{data?.titulo}</H3>
        </CardHeader>
        <CardBody>
          <div className='medium-chart'>
            <div className='recent-chart' id='recent-chart'>
              <ReactApexChart
                options={dadosFormatados.options}
                series={dadosFormatados.series}
                type='pie'
                height={355}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default PieChart;
